import { create } from "zustand";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { useStoreHome } from "../Home/useStoreHome";
import moment from "moment";
import { MensajeError, MensajeToastExito } from "../../componentes/FuncionesLocales";
import { crearRequestMercaderiasPiSeun, evaluarFiltrosMercaderia } from "../../servicios/mercaderiasPiSeun";

let claveMercaderiasEntradas = null;
let secuenciaMercaderiasEntradas = 0;

export const useStoreEntrada = create((set, get) => {
  return {
    Proceso: "",
    Mercaderia: "",
    Fecha: new Date(),
    Unidades: 1,
    Kilos: "",
    Procesando: false,
    EntradaOk: false,
    TabSeleccionado: 0,
    FechasConEntradas: [],
    Lote: "",


    limpiar: () => {
      set({
        Mercaderia: "",
        Unidades: 1,
        Kilos: "",
        CodbarLeido: null
      });
    },

    limpiezaTotal: () => {
      set({
        Proceso: "",
        Mercaderia: "",
        Unidades: 1,
        Kilos: "",
        CodbarLeido: null
      });
    },

    buscandoFechas: false,
    getFechas: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoFechas) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ buscandoFechas: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresoProceso/DistintasFechas", sParametros);

        if (data.error) {
        } else {
          var fechas = [];
          for (const item of data.data.Lista) {
            if (item.Fecha) {
              fechas.push(new Date(item.Fecha))
            }
          }
          set({ FechasConEntradas: fechas });
        }
      }
      catch (error) {
      } finally {

      }
      set({ buscandoFechas: false });

    },

    BuscandoProcesos: false,
    getProcesos: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoProcesos) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ BuscandoProcesos: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/ProcesosCliente", sParametros);
        if (data.error) {
          MensajeError(data.error);
        } else {
          set({ ListaProcesos: data.data.Lista.filter(p => p.sDescripcion?.toLowerCase().trim() !== 'faena') });
        }
      }
      catch (error) {
        MensajeError(data.error);
      } finally {

      }
      set({ BuscandoProcesos: false });

    },

    ListaMercaderias: [],
    buscandoMercaderia: false,
    limpiarResultadosMercaderias: () => {
      claveMercaderiasEntradas = null;
      secuenciaMercaderiasEntradas += 1;
      set({ ListaMercaderias: [], buscandoMercaderia: false });
    },
    getMercaderia: async ({ codigo = "", descripcion = "", signal } = {}) => {
      const evaluacion = evaluarFiltrosMercaderia({ codigo, descripcion });
      if (!evaluacion.valido) { get().limpiarResultadosMercaderias(); return []; }
      if (claveMercaderiasEntradas === evaluacion.clave) return get().ListaMercaderias;
      const miSecuencia = ++secuenciaMercaderiasEntradas;
      claveMercaderiasEntradas = evaluacion.clave;
      const sParametros = crearRequestMercaderiasPiSeun(useStoreHome.getState().EmpresaId, 0, evaluacion.filtros);
      if (!sParametros.EmpresaId) return [];
      set({ buscandoMercaderia: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/MercaderiasPiSeun", sParametros, { signal });
        if (data.aborted) return [];
        if (data.error) {
          if (miSecuencia === secuenciaMercaderiasEntradas) claveMercaderiasEntradas = null;
          return { error: data.error };
        }
        const lista = data.data?.Lista || [];
        if (miSecuencia === secuenciaMercaderiasEntradas) set({ ListaMercaderias: lista });
        return lista;
      }
      catch (error) {
        if (miSecuencia === secuenciaMercaderiasEntradas) claveMercaderiasEntradas = null;
        return { error: error.message };
      } finally {

      }
      if (miSecuencia === secuenciaMercaderiasEntradas) set({ buscandoMercaderia: false });
    },

    insertEntrada: async () => {
      if (!useStoreHome.getState().EmpresaId || get().Procesando) { return; }
      set({ Procesando: true });
      try {
        const fechaStr = moment(new Date(get().Fecha)).format("YYYY-MM-DD");
        const sParametros = {
          Proceso: get().Proceso && get().Proceso.Id ? get().Proceso : { Id: 0, sDescripcion: get().Proceso },
          Mercaderia: get().Mercaderia,
          FechaProduccion: fechaStr,
          Cantidad: get().Unidades,
          Peso: get().Kilos,
          EmpresaId: useStoreHome.getState().EmpresaId,
          OperadorId: localStorage.getItem("Id") || 0,
          Lote: get().Lote || "",
        };

        const sParametros2 = {
          ProcesoId: get().Proceso && get().Proceso.Id ? get().Proceso.Id : 0,
          MercaderiaId: get().Mercaderia && get().Mercaderia.Id ? get().Mercaderia.Id : 0,
          Fecha: fechaStr,
          FechaProduccion: fechaStr,
          Cantidad: Number(get().Kilos),
          Unidades: Number(get().Unidades),
          EmpresaId: useStoreHome.getState().EmpresaId,
          OperadorId: localStorage.getItem("Id") || 0,
          sCodbar: get().CodbarLeido ? get().CodbarLeido.sCodbar : "",
          BalanzaNeto: 0,
          Lote: get().Lote || "",
        };

        var data = {};
        if (!get().CodbarLeido) {
          data = await _Componentes_WebApiCalls_Post("IngresoProceso/InsertPiSeun", sParametros);
        }
        else {
          data = await _Componentes_WebApiCalls_Post("IngresoProceso/InsertDivision", sParametros2);
        }

        //console.log("[Entradas] insertEntrada respuesta:", data);

        if (data?.error) {
          MensajeError(data.error);
        } else {

          await get().getListaEntradasGrillaPantalla();
          set({ EntradaOk: true, TabSeleccionado: 1, CodbarLeido: null });
          MensajeToastExito("Se ingresaron los productos correctamente.");
          get().getFechas();
          get().limpiar();
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ Procesando: false });
      }
    },

    ListaGrilla: [],
    ListaDetalle: [],
    BuscandoListaEntradas: false,
    getListaEntradas: async (fechaOverride, force = false, fechaHastaOverride) => {
      if (!useStoreHome.getState().EmpresaId) return;
      if (get().BuscandoListaEntradas && !force) return;

      const fechaISO = fechaOverride || moment(new Date(get().Fecha)).format("YYYY-MM-DD");
      const fechaHastaISO = fechaHastaOverride ? moment(new Date(fechaHastaOverride)).format("YYYY-MM-DD") : moment(new Date(get().Fecha)).format("YYYY-MM-DD");

      const sParametros = {
        FechaProduccion: fechaISO,
        Fecha: fechaISO,
        FechaHasta: fechaHastaISO ? fechaHastaISO : fechaISO,
        EmpresaId: useStoreHome.getState().EmpresaId,
      };

      set({ BuscandoListaEntradas: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresoProceso/DetalleCodbarPorFecha", sParametros);

        if (data?.error) {
          MensajeError(data.error);
          set({ ListaDetalle: [], ListaGrilla: [] });
        } else {

          const listaRaw = data?.data?.Lista ?? data?.Lista ?? [];

          const lista = (Array.isArray(listaRaw) ? listaRaw : []).map(x => ({
            ...x,
            IdentificadorId: x.IdentificadorId ?? x.IndentificadorId ?? x.Id ?? x.ID,
            Proceso: x.Proceso ?? x.ProcesoDescripcion ?? x.sProceso ?? x.NombreProceso ?? '',
            sCodbar: x.sCodbar ?? x.sCodBar ?? x.CodBar ?? '',
            nUnidades: Number(x.nUnidades ?? x.nCantidad ?? x.Unidades ?? x.Cantidad ?? 0),
            nPeso: Number(x.nPeso ?? x.Peso ?? x.Neto ?? 0),
            UnidadDescripcion: x.UnidadDescripcion ?? x.Unidad ?? x.Unidad_Descripcion ?? '',
            ProcesoId: x.ProcesoId ?? x.procesoId ?? x.Proceso ?? undefined,
            
          }));
          set({ ListaDetalle: lista, ListaGrilla: lista });

          if (Array.isArray(lista) && lista.length > 0) {
          } else {
            set({ ListaGrilla: [] });
          }
        }

      } catch (error) {
        MensajeError(error.message);
        set({ ListaDetalle: [], ListaGrilla: [] });

      } finally {
        set({ BuscandoListaEntradas: false });
      }
    },


    getListaEntradasGrillaPantalla: async () => {
      if (!useStoreHome.getState().EmpresaId) return;
      if (get().BuscandoListaEntradas) return;


      const sParametros = {
        FechaProduccion: moment(get().Fecha).format("YYYY-MM-DD"),
        Fecha: moment(get().Fecha).format("YYYY-MM-DD"),
        FechaHasta: moment(get().Fecha).format("YYYY-MM-DD"),
        EmpresaId: useStoreHome.getState().EmpresaId,
      };

      set({ BuscandoListaEntradas: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresoProceso/DetalleCodbarPorFecha", sParametros);

        if (data?.error) {
          MensajeError(data.error);
        } else {

          const listaRaw = data?.data?.Lista ?? data?.Lista ?? [];

          const lista = (Array.isArray(listaRaw) ? listaRaw : []).map(x => ({
            ...x,
            IdentificadorId: x.IdentificadorId ?? x.IndentificadorId ?? x.Id ?? x.ID,
            Proceso: x.Proceso ?? x.ProcesoDescripcion ?? x.sProceso ?? x.NombreProceso ?? '',
            sCodbar: x.sCodbar ?? x.sCodBar ?? x.CodBar ?? '',
            nUnidades: Number(x.nUnidades ?? x.nCantidad ?? x.Unidades ?? x.Cantidad ?? 0),
            nPeso: Number(x.nPeso ?? x.Peso ?? x.Neto ?? 0),
            UnidadDescripcion: x.UnidadDescripcion ?? x.Unidad ?? x.Unidad_Descripcion ?? '',
            ProcesoId: x.ProcesoId ?? x.procesoId ?? x.Proceso ?? undefined,
            
          }));
          set({ ListaDetalleGrilla: lista });

          if (Array.isArray(lista) && lista.length > 0) {
          } else {
            set({ ListaDetalleGrilla: [] });
          }
        }

      } catch (error) {
        MensajeError(error.message);

      } finally {
        set({ BuscandoListaEntradas: false });
      }
    },



    Seleccionados: [],
    Eliminando: false,
    eliminarEntrada: async (items) => {
      if (!useStoreHome.getState().EmpresaId || get().Eliminando) return;
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        OperadorId: Number(localStorage.getItem("Id") || 0),
        lstBarras: JSON.stringify(items),
      };

      set({ Eliminando: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresoProceso/EliminarEntradaPiseun", sParametros);
        if (data?.error || data?.data?.Error) {
          MensajeError(data?.error || data?.data?.Error);
          return;
        }
        set({ Seleccionados: [] });
        get().getListaEntradasGrillaPantalla();
        get().getFechas();
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ Eliminando: false });
      }
    },

    BuscandoCodbar: false,
    CodbarLeido: null,
    getCodbar: async (codbar) => {
      if (!useStoreHome.getState().EmpresaId || !codbar || get().BuscandoCodbar) { return; }

      const sParametros = {
        sCodbar: codbar,
        Insertar: false,
        EmpresaId: useStoreHome.getState().EmpresaId,
      };

      try {
        set({ BuscandoCodbar: true });
        const data = await _Componentes_WebApiCalls_Post("IngresoProceso/LecturaCodbar", sParametros);

        if (data?.error) {
          set({ CodbarLeido: null })
          MensajeError(data.error);
        }
        else {

          if (data.data.Lista && data.data.Lista[0]) {
            if (data.data.Lista[0].MercaderiaId) {
              set({ Mercaderia: { Id: data.data.Lista[0].MercaderiaId, sDescripcion: data.data.Lista[0].MercaderiaDescripcion, sCodigo: data.data.Lista[0].MercaderiaCodigo } });
              set({ Unidades: data.data.Lista[0].nUnidades || "" });
              set({ Kilos: data.data.Lista[0].nPeso || "" });
            }
          }
          set({ CodbarLeido: data.data.Lista && data.data.Lista[0] ? data.data.Lista[0] : null });
        }

      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ BuscandoCodbar: false });
      }
    },


    MercaderiaUnidad: null,
    buscandoMercaderiaUnidad: false,
    getMercaderiaUnidad: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoMercaderiaUnidad || !get().Mercaderia || !get().Mercaderia.Id) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, Id: get().Mercaderia.Id };
      set({ buscandoMercaderiaUnidad: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Mercaderias/GetUnidadPorMercaderia", sParametros);
        if (data.error) {
          MensajeError(data.error);
        } else {
          set({ MercaderiaUnidad: data.data });
        }
      }
      catch (error) {
        MensajeError(error.message);
      } finally {

      }
      set({ buscandoMercaderiaUnidad: false });

    },

  };
});
